import { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { drawerWidth } from "../../../template/MainTemplate";
import {
  Toolbar,
  Box,
  Divider,
  SwipeableDrawer,
  List,
  Collapse,
  ListItemIcon,
  ListItemButton,
  ListItemText,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  DashboardOutlined as DashboardOutlinedIcon,
  ReceiptOutlined as ReceiptOutlinedIcon,
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
  Discount as DiscountIcon,
  CardGiftcard as CardGiftcardIcon,
} from "@mui/icons-material";
import { useSelector } from "react-redux";
import { RootStateType } from "src/app/store";

const drawerCategories = [{ id: 1, title: "فایل ها" }];

const MenuItems = [
  {
    title: "مدیریت فایل ها",
    icon: <DiscountIcon fontSize="small" />,
    path: "/files/uploaded-files",
    categoryId: 1,
    disable: false,
  },
];

type TemporaryDrawerPropsType = {
  mobileOpen: boolean;
  handleDrawerToggle: () => void;
};

export default function TemporaryDrawer({
  handleDrawerToggle,
  mobileOpen,
}: TemporaryDrawerPropsType) {
  const theme = useTheme();
  const isLg = useMediaQuery(theme.breakpoints.up("lg"));
  // const accessTokenValue: any = useSelector(
  //   (state: RootStateType) => state.auth?.accessToken
  // );

  const roleId: number[] | undefined = useSelector(
    (state: RootStateType) => state.auth?.roleId
  );

  // var decoded: any = jwt_decode(accessTokenValue as string);

  const processedAccessToken: any = {};

  // for (const key in decoded) {
  //   if (decoded.hasOwnProperty(key)) {
  //     const lastIndex = key.lastIndexOf("/");
  //     const value = decoded[key];
  //     const newKey = key.substring(lastIndex + 1);
  //     processedAccessToken[newKey] = value;
  //   }
  // }

  // const userRoles = JSON.parse(processedAccessToken.role);
  // const allRoleKeys = Object.keys(userRoles).map(Number);
  const [open, setOpen] = useState([false, false, false]);
  const { pathname: appCurrentPath } = useLocation();

  const isSelected = (paths: string[]) => {
    const index = paths.findIndex((path) => appCurrentPath === path);
    if (index >= 0) {
      return true;
    } else {
      return false;
    }
  };

  const isParentSelected = ({
    paths,
    parentIndex,
  }: {
    paths: string[];
    parentIndex: number;
  }) => {
    if (open[parentIndex]) return;
    const idx = paths.findIndex((path) => appCurrentPath === path);
    if (idx >= 0) {
      return true;
    } else {
      return false;
    }
  };

  const listItemClickHandler = (index: number) => {
    setOpen((prevState) => {
      let newState = [false, false, false];
      newState[index] = !prevState[index];
      return newState;
    });
  };

  const navigate = useNavigate();

  const listSubItemClickHandler = (path: string) => {
    !isLg && handleDrawerToggle();
    navigate(path);
  };

  const drawerBoxItems = ({
    listArray,
    title,
    index,
    disable,
    show,
  }: {
    listArray: any[];
    title: string;
    index: number;
    disable?: boolean;
    show?: boolean;
  }) => {
    return (
      <div key={index}>
        <ListItemButton
          selected={isParentSelected({
            paths: listArray.map(({ path }) => path),
            parentIndex: index,
          })}
          onClick={() => listItemClickHandler(index)}
          disabled={disable}
          sx={{
            display: listArray.every((obj) => obj.disable === true)
              ? "none"
              : "",
          }}
        >
          {open[index] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          <ListItemText
            primaryTypographyProps={{
              sx: {
                color: "black",
                fontWeight: "500",
                fontSize: "0.9rem",
              },
            }}
            sx={{ ml: 2 }}
            primary={title}
          />
        </ListItemButton>
        <Collapse in={open[index]} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {listArray.map(({ icon, path, title, disable }, index) => (
              <ListItemButton
                selected={isSelected([path])}
                onClick={() => listSubItemClickHandler(path)}
                key={index}
                sx={{ pl: 4 }}
                style={disable ? { display: "none" } : { display: "" }}
              >
                <ListItemIcon sx={{ minWidth: "auto" }}>{icon}</ListItemIcon>
                <ListItemText
                  primaryTypographyProps={{
                    sx: {
                      fontWeight: "400",
                      fontSize: "0.85rem",
                    },
                  }}
                  sx={{ ml: 1 }}
                  primary={title}
                />
              </ListItemButton>
            ))}
          </List>
        </Collapse>
      </div>
    );
  };

  const drawerItems = (
    <Box>
      <Toolbar />
      <Divider />
      <List sx={{ overflow: "auto" }}>
        <ListItemButton
          selected={isSelected(["/"])}
          onClick={() => {
            setOpen([false, false, false]);
            listSubItemClickHandler("/");
          }}
        >
          <ListItemIcon sx={{ minWidth: "auto" }}>
            <DashboardOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{
              sx: {
                color: "black",
                fontWeight: "500",
                fontSize: "0.9rem",
              },
            }}
            sx={{ ml: 2 }}
            primary="صفحه اصلی"
          />
        </ListItemButton>
        <ListItemButton
          selected={isSelected(["/channel"])}
          onClick={() => {
            setOpen([false, false, false]);
            listSubItemClickHandler("/channel");
          }}
        >
          <ListItemIcon sx={{ minWidth: "auto" }}>
            <DashboardOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{
              sx: {
                color: "black",
                fontWeight: "500",
                fontSize: "0.9rem",
              },
            }}
            sx={{ ml: 2 }}
            primary="دسته بندی ها"
          />
        </ListItemButton>
        {/* <ListItemButton
          selected={isSelected(["/videos"])}
          onClick={() => {
            setOpen([false, false, false]);
            listSubItemClickHandler("/videos");
          }}
        >
          <ListItemIcon sx={{ minWidth: "auto" }}>
            <DashboardOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{
              sx: {
                color: "black",
                fontWeight: "500",
                fontSize: "0.9rem",
              },
            }}
            sx={{ ml: 2 }}
            primary="ویدیو ها"
          />
        </ListItemButton> */}
        {drawerCategories.map((dC, index) => {
          return drawerBoxItems({
            listArray: MenuItems.filter((mI) => mI.categoryId === dC.id),
            title: dC.title,
            index,
          });
        })}
      </List>
    </Box>
  );

  return (
    <SwipeableDrawer
      variant={isLg ? "persistent" : "temporary"}
      open={mobileOpen}
      onOpen={() => { }}
      onClose={handleDrawerToggle}
      ModalProps={{
        keepMounted: true, // Better open performance on mobile.
      }}
      sx={{
        display: "block",
        "& .MuiDrawer-paper": {
          boxSizing: "border-box",
          width: drawerWidth,
        },
      }}
    >
      {drawerItems}
    </SwipeableDrawer>
  );
}
